import React, { useState } from "react";
import Footer from "../Footer/Footer";
import Header from "../Header/Header";

function SportsBetting() {
    const [isCustomizeOpen, setIsCustomizeOpen] = useState(true);

    const toggleCustomize = () => {
        setIsCustomizeOpen(prev => !prev);
    };

    return (
        <div>
            <Header changeColor="darkNavy" />
            <div style={{ width: "100%", marginTop: "-100px", height: "100vh", position: "relative" }}>
                <div
                    className={`right-container ${isCustomizeOpen ? "hide" : "show"}`}
                    onClick={toggleCustomize}
                >
                    <div className="circle-info">
                        <span className="info-stytle">i</span>
                    </div>
                </div>
                <div className={`Customize-content ${isCustomizeOpen ? "open" : "closed"}`}>
                    <div className="circle-close" onClick={toggleCustomize}>
                        <span className="close-sign">x</span>
                    </div>
                    <div className="info-icon">
                        <span className="title-customizeInfo">Info!</span>
                        <div className="circle-info">
                            <span className="info-stytle">i</span>
                        </div>
                    </div>
                    <span className="title-customize">
                        Our sports betting platform is optimized for top-tier performance and offers full customization options, allowing you to personalize the layout, odds display, and branding for a unique and immersive experience tailored to your audience.
                    </span>
                </div>

                <iframe
                    title="Sportsbetting Prototype"
                    style={{
                        width: "100%",
                        height: "100vh",
                        border: "none"
                    }}
                    src="https://embed.figma.com/proto/sKnUbAnIHj4sBXr9IEXVI9/Sports-Betting-for-Demo?page-id=0%3A1&node-id=1-2&p=f&viewport=393%2C73%2C0.11&scaling=min-zoom&content-scaling=fixed&embed-host=share&hide-ui=1"
                    allowFullScreen
                ></iframe>
            </div>

            <Footer changeColor="darkNavy" />
        </div>
    );
}

export default SportsBetting;
